import { useState, useEffect } from 'react';
import { map } from 'lodash'

import grammarDB from '../../../documents/English/grammar.json';

import { Col, Container, Row, Spinner } from 'react-bootstrap';
import ReturnBar from '../../../components/ReturnBar/ReturnBar';
import CardItem from '../../../components/Cards/CardItem/CardItem';
import PdfModal from '../../../components/Modal/PdfModal/PdfModal';
import './Grammar.scss';

export default function GrammarEnglish() {

    const [showModal, setShowModal] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [contentModal, setContentModal] = useState(null);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setData(grammarDB);
        setIsLoading(false);
    }, []);

    return (
        <div className="grammar">
            <ReturnBar />
            {
                isLoading ? (
                    <div className="grammar__loading">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <Container>
                        <h2 className="grammar__titulo">Grammar</h2>
                        <Row>
                            {
                                map(data, items => (
                                    <Col lg={12} md={12} className="gy-5" key={items.id} >
                                        <CardItem
                                            element={items}
                                            setShowModal={setShowModal}
                                            setTitleModal={setTitleModal}
                                            setContentModal={setContentModal}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                )
            }

            <PdfModal show={showModal} setShow={setShowModal} title={titleModal}>
                {contentModal}
            </PdfModal>
        </div>
    );
}